module.exports = __webpack_public_path__ + "img/at.78ef3ba4.svg";